// extracted by mini-css-extract-plugin
export default {"root":"DateRange_root__WZkvy","hint":"DateRange_hint__doWfC"};